<template>
  <div class="mb-24">
      <div class="text-white flex-1 col-span-1 border-0 rounded-t-xl overflow-hidden">
        <div class="bg-theme-green px-4 py-2 text-white">
          <div class="flex justify-between items-center">
            <div class="flex flex-col justify-start text-start ">
              <h2 class="font-semibold truncate text-single-line break-all mb-0.5 text-xl leading-6 mt-0 ml-2 capitalize">{{item.transactionType}}</h2>
            </div>
            
            <div class="flex flex-col">
              <div class="flex items-center content-center gap-2">
                <button  @click.prevent="clearComponent" class="text-base flex items-center justify-center text-center  h-[44px] tracking-[0.15px] font-medium cursor-pointer  p-4 rounded hover:opacity-60  text-white ml-3">CLOSE</button>
              </div>
            </div>
          </div>
        </div>

        <div class="bg-[#2B2C32] px-[16px] py-[16px] rounded-b-lg">
          <div class="flex items-center  xl:flex-row flex-col gap-3 mb-3">   
            <div class="w-full xl:w-1/2">
              <div class='input-wrapper '>
                <label class="text-sm leading-[17.5px]">Date</label>
                <span class="  flex items-center p-2 text-white h-[40px] rounded  bg-[#1C1D21] w-full leading-5 text-base">
                  <p class="mr-2">{{formatDate(item.createdAt)}}</p>
                </span>
              </div>
            </div>
            <div class="w-full xl:w-1/2">
              <div class='input-wrapper relative ' >
                <label class="text-sm leading-[17.5px]">User</label>
                <span class=" flex items-center p-2 text-white h-[40px] rounded  bg-[#1C1D21] w-full leading-5 text-base">
                  <p>{{item.createdByName}}</p>
                  
                </span>
              </div>
            </div>
          </div>
          <div class="flex items-center  xl:flex-row flex-col gap-3 mb-3">   
            <div class="w-full xl:w-1/2">
              <div class='input-wrapper '>
                <label class="text-sm leading-[17.5px]">Transaction Type</label>
                <span class=" flex items-center p-2 text-white h-[40px] rounded  bg-[#1C1D21] w-full leading-5 text-base">
                  <p>{{item.transactionType}}</p>
                </span>
              </div>
            </div>
            <div class="w-full xl:w-1/2">
              <div class='input-wrapper relative ' >
                <label class="text-sm leading-[17.5px]">Amount</label>
                <span :class="item.transactionType=='remove cash'?'text-[#FF6868]':''" class=" flex items-center p-2 h-[40px] rounded  bg-[#1C1D21] w-full leading-5 text-base">
                  <p>{{getAmount(item)}}</p>
                </span>
              </div>
            </div>
          </div>
          <div v-if="item.transactionType=='bank deposit'" class="flex items-center  xl:flex-row flex-col gap-3 mb-3">   
            <div class="w-full xl:w-1/2">
              <div class='input-wrapper '>
                <label class="text-sm leading-[17.5px]">Bank Deposit #</label>
                <span class=" flex items-center p-2 text-white h-[40px] rounded  bg-[#1C1D21] w-full leading-5 text-base">
                  <p>{{item.depositId}}</p>
                </span>
              </div>
            </div>
          </div>
          <div class="w-full">
              <div class="input-wrapper relative ">
                <label class="text-sm leading-[17.5px]">Notes</label>
                <p class=" h-[80px] rounded bg-[#1C1D21] text-white p-2 w-full leading-5 text-base">{{item.note}}</p>
              </div>
            </div>
          </div>
      </div>
  </div>
</template>


<script lang="ts">
import {defineComponent} from "vue"
import moment from 'moment'

export default defineComponent({
  name: "ViewCash",
   props:{
    item: {
      type: Function,
      required: true,
    },
    clearComponent: {
      type: Function,
      required: true,
    },
  },
  methods: {
    getAmount(item){
      if(item.transactionType=='remove cash'){
        return item.amount?'-$'+item.amount.toFixed(2):'0.00'
      }else{
        return item.amount?'$'+item.amount.toFixed(2):'0.00'
      }
    },
    formatDate(date){
      if(!date) return
      return moment(date).format('YYYY-MM-DD h:mm:s a')
    }
  }
});

</script>
